<template>
  <!-- 活动中心-推广活动-推广活动管理 -->
  <div class="partner_config-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="configVisible = true"
            >活动配置</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->

    <!-- 弹窗 -->
    <!-- 活动配置 -->
    <PartnerDialog
      v-model="dialogInfos"
      :visible="configVisible"
      :type="dialogType"
      @close="configVisible = false"
      @refresh="getData()"
    ></PartnerDialog>
  </div>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import http, {
  server,
  api,
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '@/http'
import PartnerDialog from '@/components/activities/partner/PartnerDialog.vue'


export default {
  components: {
    PartnerDialog
  },
  data() {
    return {
      configVisible: false,//配置弹窗显示标志
      loading: false, //加载动画
      switchStatus: 0,//打开或关闭 0是关闭 1是打开
      query: {
        page: 1
      },
      dataForm: {
        start_time: '',//开始时间
        end_time: '',//结束时间
      },
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//传给弹窗的数据
      dataList: undefined, //数据列表
      dataMeta: undefined, //底部跳转页面条
    }
  },
  created() {
    // this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      getApiData('').then(res => {
        if (res) { }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}

</script>
<style lang="less" scoped>
.partner_config-box {
  header {
  }

  .body-box {
  }
}
</style>
